// ---------------------------
// code to update url attributes and behavior
export function isLocalUrl(urlToCheck) {
  if (!urlToCheck) return false;
  return urlToCheck.startsWith(SITEBASEURL.replace(/\/$/, ''));
}

function getLinkType(url) {
  if (!url) return 'empty';
  if (isLocalUrl(url)) return 'local';
  return 'external';
}

function getAttributesString(urlToCheck, placeholder) {
  const type = getLinkType(urlToCheck);

  switch (type) {
    case 'empty':
      return placeholder
        ? `aria-label="${placeholder}" aria-disabled="true"`
        : `aria-disabled="true"`;

    case 'local':
      return placeholder ? `aria-label="${placeholder}"` : '';

    case 'external': {
      const label = placeholder ? `aria-label="${placeholder} (opens in a new tab)"` : '';
      return `target="_blank" rel="noopener noreferrer" ${label}`;
    }
  }
}

function setAttributesDOM($el, urlToCheck, placeholder) {
  const type = getLinkType(urlToCheck);

  switch (type) {
    case 'empty':
      $el.removeAttr('href').addClass('void-link');
      $el.attr('aria-disabled', 'true');
      if (placeholder) $el.attr('aria-label', placeholder);
      break;

    case 'local':
      if (placeholder) $el.attr('aria-label', placeholder);
      break;

    case 'external':
      $el.attr({ target: '_blank', rel: 'noopener noreferrer' });
      if (placeholder) $el.attr('aria-label', `${placeholder} (opens in a new tab)`);
      break;
  }
}

export function updateLinksAttributes(urlToCheck, placeholder, $el = null) {
  if ($el) {
    setAttributesDOM($el, urlToCheck, placeholder);
    return;
  }

  return getAttributesString(urlToCheck, placeholder);
}
